/**
 *
 * Loader
 *
 */
import React, { memo } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { messages } from './messages';

interface Props {}

export const Loader = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();

  return (
    <Div className="text-center mt-5">
      <div className="spinner-border text-primary" role="status"></div>
      {/*  {t(...messages.someThing())}  */}
    </Div>
  );
});

const Div = styled.div``;
